"use client";

import { ReactNode, useState } from "react";
import { cn } from "@/lib";
import {
  BdAltArrowDown,
  BdAltArrowLeft,
  BdMentionSquare,
} from "solar-icon-react/bd";
import Link from "next/link";
import { IService } from "@/interfaces";

interface AccordionMenuProps {
  category: string;
  icon: ReactNode;
  items: IService[];
  className?: string;
  closeSidebar: () => void;
}

const AccordionMenu = ({
  category,
  icon,
  items,
  className,
  closeSidebar,
}: AccordionMenuProps) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <article className={cn("flex flex-col", className)}>
      <div
        onClick={() => setIsOpen(!isOpen)}
        className={cn("flex cursor-pointer items-center gap-2 lg:gap-4")}
      >
        <div className="flex items-center justify-center">
          {icon || (
            <BdMentionSquare size={35} className={cn("text-primary-main!")} />
          )}
        </div>
        <div
          className={cn("flex gap-0.5")}
          id={`sidebar-category-${Math.ceil(Math.random() * 1000000)}`}
        >
          <h2
            className={cn(
              "text-primary-main flex items-center justify-center text-sm font-bold lg:text-base",
            )}
          >
            {category}
          </h2>
          {isOpen ? (
            <BdAltArrowDown
              size={25}
              className={cn(
                "text-primary-main! flex items-center justify-center",
              )}
            />
          ) : (
            <BdAltArrowLeft size={25} className={cn("text-primary-main!")} />
          )}
        </div>

        <div className={cn("flex cursor-pointer gap-0.5")}></div>
      </div>
      {isOpen && (
        <ul
          className={cn(
            "ms-18 mt-4 flex w-full flex-col justify-center gap-4 lg:gap-6",
          )}
        >
          {items.map((item, index) => (
            <li
              key={index}
              className={cn(
                "text-custom-gray-600 hover:text-secondary-main text-sm transition-colors lg:text-base",
                item.disabled === "unavailability" &&
                  "text-custom-gray-100 pointer-events-none",
              )}
            >
              <Link
                id={`sidebar-service-${item.flag}`}
                title={item.label}
                aria-disabled={item.disabled === "unavailability"}
                href={item.disabled !== "unavailability" ? item.href : "#"}
                onClick={closeSidebar}
              >
                {item.label}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </article>
  );
};

export default AccordionMenu;
